import * as actionTypes from "./actionTypes";

export const switchShowMap = (showMap) => {
  return {
    type: actionTypes.SWITCH_SHOWMAP,
    showMap: !showMap,
  };
};
